











































































import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {ApiMessage, PendingCardReply, PhoneNumber} from "../../modules/models";
import rd from "../../modules/vRoutedefs";
import HmsCardDisplay from "../HmsCardDisplay.vue";
import UserRequired from "../UserRequired";
import {ignoreRedundantNavErr} from "@/router";

@Component({
    components: {
        "at-card-display": HmsCardDisplay,
    }
})
export default class PendingCardProcess extends UserRequired {
    @Inject()
    api!: Api;

    @Prop()
    cardNum!: number;

    ALREADY_CONNECTED = PendingCardReply.ALREADY_CONNECTED;
    ADD_NEW = PendingCardReply.ADD_NEW;
    MERGE = PendingCardReply.MERGE;
    TAKEOVER = PendingCardReply.TAKEOVER;
    startRoute = rd.start.path;
    retryRoute = rd.start.card.add.path;

    fetching = true;
    reply: PendingCardReply | null = null;
    errMsg: ApiMessage | null = null;

    get userPerson() {
        return this.user.person;
    }

    get card() {
        return this.reply != null && this.reply.card != null ? this.reply.card : null;
    }
    get nextOp() {
        return this.reply != null ? this.reply.nextOp : 0;
    }
    get otherPerson() {
        return this.reply != null && this.reply.otherPerson != null ? this.reply.otherPerson : null;
    }
    get otherPersonPhones(): PhoneNumber[] {
        return this.reply != null && this.reply.otherPersonPhones != null ? this.reply.otherPersonPhones : [];
    }
    get otherPersonPhonesList(): string {
        return this.otherPersonPhones.join(", ");
    }

    @Watch("cardNum", {immediate: true})
    async onCardNumChanged() {
        this.fetching = true;
        try {
            const reply = await this.api.pendingCard(this.cardNum);
            if (reply instanceof ApiMessage) {
                this.reply = null;
                this.errMsg = reply;
            } else {
                this.reply = reply;
                this.errMsg = null;
            }
        } finally {
            this.fetching = false;
        }
    }

    // Add pending card as new card connected to user
    async addNew() {
        if(this.card != null) {
            await this.api.pendingCardAdd(this.card.cardNum);
            this.baseApi.loadUser(); // Refresh user info to display the added card
            this.$emit("at-snackmsg", "Nytt kort lagt til");
            await ignoreRedundantNavErr(this.$router.replace({path: this.startRoute}));
        }
    }

    // Merge logged in user into user that currently has card attached.
    async merge() {
        if(this.card != null) {
            await this.api.pendingCardMerge(this.card.cardNum);
            this.baseApi.loadUser(); // Refresh user info to display post-merged user info
            this.$emit("at-snackmsg", "Brukersammenslåing utført");
            await ignoreRedundantNavErr(this.$router.replace({path: this.startRoute}));
        }
    }

    // Move card and related data to logged in user.
    async takeover() {
        if(this.card != null) {
            await this.api.pendingCardTakeover(this.card.cardNum);
            this.baseApi.loadUser(); // Refresh user info to display post-takeover user info
            this.$emit("at-snackmsg", "Kortovertakelse utført");
            await ignoreRedundantNavErr(this.$router.replace({path: this.startRoute}));
        }
    }
}
